import React from "react";
import classes from "./SharedWithMeArticlesList.module.css";
import SharedWithMeArticleItem from "./dashboard/shared-with-me-tab/SharedWithMeArticleItem";
import DashboardMessageContainer from "./DashboardMessageContainer";

function SharedWithMeArticlesList({ articlesList }) {
  return (
    <div className={classes.listContainer}>
      {articlesList.length > 0 ? (
        <>
          <p className={classes.listTitle}>
            You can help authors to improve the quality of their articles by
            suggesting changes to them
          </p>
          {articlesList?.map((sharedArticle, key) => (
            <SharedWithMeArticleItem
              key={key}
              article={sharedArticle.article}
              reviewRequestId={sharedArticle.reviewRequestId}
              reviewRequestStatus={sharedArticle.reviewRequestStatus}
            />
          ))}
        </>
      ) : (
        <DashboardMessageContainer
          message="No reviews in progress!"
          status="empty"
        />
      )}
    </div>
  );
}

export default SharedWithMeArticlesList;
